import styled from "@emotion/styled"
import { FormControlLabel, Radio, RadioGroup } from "@mui/material"
import { Dispatch, SetStateAction } from "react"
import colors from "theme/colors"
import { trackAppWalletInfo } from "./ChargeGTM"
import { AppType, useAppType } from "contexts/AppTypeProvider"

const Container = styled("div")`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`



const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  position: relative;
  flex-direction:row;
  background-color: #fff;
  box-shadow: 0px 20px 40px 0px #8288944d;
  padding: 12px;
  border-radius: 56px;
  * {
    z-index: 2;
  }

  @media (max-width: 700px) {
    transform: scale(0.6);
  }
`

const StyledFormControlLabel = styled(FormControlLabel)`
position:relative;
margin:0;
height: 36px;
width: 152px;
font-size: 20px;
line-height: 28px;
font-weight: ${(props) => (props.checked ? "500" : "400")};
& .MuiTypography-root{
  display:none;
}
& .MuiButtonBase-root{
  padding:0;
}
${(props) => props.theme.breakpoints.up("md")} {
    font-size: 24px;
    line-height: 33.6px;
    height: 50px;
    width: 186px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    font-size: 36px;
    line-height: 50.4px;
    height: 74px;
    width: 280px;
  }

  :focus-within{
  border: 1px solid ${colors.gray};
  border-radius: 36px;
}
`

const Tab = styled("div") <{ checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 152px;
  font-size: 20px;
  line-height: 28px;
  font-weight: ${(props) => (props.checked ? "500" : "400")};
  border-radius: 36px;
  cursor: pointer;
  transition: color 0.15s ease-in;
  color: ${colors.black};

  ${(props) => props.theme.breakpoints.up("md")} {
    font-size: 24px;
    line-height: 33.6px;
    height: 50px;
    width: 186px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    font-size: 36px;
    line-height: 50.4px;
    height: 74px;
    width: 280px;
  }
`

const Glider = styled("span") <{ index: number }>`
  position: absolute;
  display: flex;
  height: 36px;
  width: 152px;

  background-color: ${colors.yellow};
  z-index: 1;
  border-radius: 36px;
  transition: 0.25s ease-out;
  transform: ${(props) => {
    return `translateX(${props.index * 100}%)`
  }};
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 50px;
    width: 186px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    height: 74px;
    width: 280px;
  }
`

const StyledContainer = styled.div`
  height: 98px;
  position: relative;
  margin-bottom: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-bottom: 24px;
  }
`

type Props = {
  tabs: { label: string; id: number }[]
  setSelectedTab: Dispatch<SetStateAction<number>>
  selectedTab: number
}

function RadioIcon({ text, checked }: { text: string; checked: boolean }) {
  return <Tab checked={checked}>{text}</Tab>
}

function MyTabs({ tabs, selectedTab, setSelectedTab }: Props) {
  const {appType} = useAppType()
  const handleChangeNew = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedTab(Number(event.target.value));
    if(appType === AppType.Charge){
      trackAppWalletInfo(tabs[Number(event.target.value)].label)
    }
  };
  return (
    <StyledContainer>
      <Container>
        <StyledRadioGroup
          aria-label="איך צוברים או איפה ממשים"
          value={selectedTab}
          name="radio-group"
          onChange={handleChangeNew}
        >
          {tabs.map((tab, index: number) => (

            <StyledFormControlLabel
              key={index}
              value={tab.id}
              control={
                <Radio
                  name="radio-group"
                  disableRipple
                  checkedIcon={<RadioIcon text={tab.label} checked={selectedTab === tab.id} />}
                  icon={<RadioIcon text={tab.label} checked={selectedTab === tab.id} />}
                />
              }
              label={tab.label}
            />
          ))}
          <Glider index={selectedTab} />
        </StyledRadioGroup>
      </Container>
    </StyledContainer>
  )
}

export default MyTabs
